<a
    class="user-label"
    *ngIf="user$ | async; let user"
    [routerLink]="['/users', user.id]"
>
    <img class="user-label__image" [src]="user.thumbnail" />
    <span class="user-label__name">{{ user.username }}</span>
</a>
